export default (percent: number) => {
  return `radial-gradient(circle, rgba(0,0,0,0) 0%, rgba(0,0,0,0) ${percent}%,  rgba(229,63,63,0.5) 90%, rgba(229,63,63,0.9) 100%)`;
};
